import { useCallback, useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { IncidentsService } from '../../../../../services/incidentsService';
import { useNotifications } from '../../../../../hooks/useNotifications';
import { repeatServicesTimeUnits } from '../../../../../config/constants/incidentsConstants';

const useValidateAvailability = ({ incidentData }) => {
  const [datesAvailability, setDatesAvailability] = useState([]);
  const { totalAppointments, availableCount } = useMemo(() => {
    return {
      totalAppointments: datesAvailability.length,
      availableCount: datesAvailability.reduce((count, { isAvailable }) => (isAvailable ? count + 1 : count), 0),
    };
  }, [datesAvailability]);
  const [isLoading, setIsLoading] = useState(false);
  const { showErrorNotification } = useNotifications();

  const checkDatesAvailability = useCallback(
    async ({ idTypeService, idUser, idFinalCustomer, dates }) => {
      setIsLoading(true);
      try {
        const data = await IncidentsService.getDatesAvailability({
          idTypeService,
          idUser,
          idFinalCustomer,
          dates,
        });
        setDatesAvailability(data.datesAvailability);
      } catch (error) {
        showErrorNotification({
          title: 'error',
          description: 'errorRetrievingRecords',
        });
      } finally {
        setIsLoading(false);
      }
    },
    [showErrorNotification],
  );

  const getDateAvailability = useCallback(() => {
    if (!incidentData) {
      return;
    }
    const { repeatInfo, start } = incidentData;
    const { repeatTimes, timeUnit, howOften } = repeatInfo;
    const dates = [];
    const timeUnitValue = repeatServicesTimeUnits.find(({ value }) => value === timeUnit);
    while (dates.length < repeatTimes) {
      const date = moment(start).add(howOften * dates.length, timeUnitValue.label);
      dates.push(date.toISOString());
    }
    checkDatesAvailability({
      idTypeService: incidentData.idTypeService,
      idUser: incidentData.idUser,
      idFinalCustomer: incidentData.idFinalCustomer,
      dates,
    });
  }, [incidentData, checkDatesAvailability]);

  useEffect(() => {
    getDateAvailability();
  }, [getDateAvailability]);

  return {
    checkDatesAvailability,
    datesAvailability,
    isLoading,
    totalAppointments,
    availableCount,
  };
};

export default useValidateAvailability;
